import { LogOut } from "lucide-react";
import { LexeLogo } from "@/components/ui/LexeLogo";
import { useLogtoAdmin } from "@/services/auth/logto-provider";

export function SessionExpiredPage() {
  const { signIn } = useLogtoAdmin();

  const handleLogin = () => {
    signIn(`${window.location.origin}/callback`);
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="text-center space-y-6 max-w-md px-4">
        <div className="flex items-center justify-center">
          <LexeLogo size="lg" />
        </div>
        <div className="space-y-2">
          <LogOut className="h-12 w-12 text-muted-foreground mx-auto" />
          <h2 className="text-xl font-semibold text-foreground">Sessione scaduta</h2>
          <p className="text-muted-foreground">
            La tua sessione e' scaduta. Effettua nuovamente l'accesso per continuare.
          </p>
        </div>
        <button
          onClick={handleLogin}
          className="inline-flex items-center gap-2 rounded-md bg-primary px-6 py-3 text-sm font-medium text-primary-foreground hover:bg-primary/90 transition-colors"
        >
          Accedi di nuovo
        </button>
      </div>
    </div>
  );
}
